export const correctDate = (date: Date) =>
  new Date(Date.parse(date.toUTCString()) - date.getTimezoneOffset() * 60000);
